import get from 'lodash/get';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/resource/redux';
export const statePath = 'gandiReduxResourceCoupon';
const baseUrl = '/discount/vouchers';
export const initialState = () => [];
const toQueryParameter = (props = {}) => Object.keys(props).map(key => {
  if (key !== 'sharingId') {
    return `${key}=${props[key]}`;
  }
  return `sharing_id=${props[key]}`;
}).join('&');
export const resource = createResource('coupons');
export default createReducer({
  [resource.fetch.success.getType()]: (state, {
    response: {
      data
    }
  }) => data.map(d => ({
    consumed: d.consumed,
    code: d.code,
    promotion: {
      code: d.promotion.code,
      rebate: d.promotion.rebate,
      type: d.promotion.type,
      unit: d.promotion.unit,
      dateStart: new Date(d.promotion.date_start),
      dateEnd: new Date(d.promotion.date_end)
    }
  }))
}, initialState());
export const fetchLabel = props => props ? toQueryParameter(props) : 'default';
export const fetch = props => resource.fetch(baseUrl + (props ? `?${toQueryParameter(props)}` : ''), {
  label: fetchLabel(props),
  ...props
});
export const fetchAll = ({
  sharingId
}) => fetch({
  consumed: 0,
  sharingId
});
const selectRaw = state => get(state, statePath, initialState());
export const selectIsLoaded = (state, props) => resource.selectIsLoaded(state, fetchLabel(props));
export const selectIsFetching = (state, props) => resource.selectIsFetching(state, fetchLabel(props));
export const selectIsFailure = (state, props) => resource.selectIsFailure(state, fetchLabel(props));
export const selectIsToRefetch = (state, props) => resource.selectIsToRefetch(state, fetchLabel(props));
export const selectAll = createSelector([selectRaw, (_, props = {}) => props.consumed, (_, props = {}) => {
  if (!props.name) return undefined;
  return new RegExp(`^${props.name.replace(/\*/g, '.*')}$`);
}, (_, props = {}) => {
  if (!props.code) return undefined;
  return new RegExp(`^${props.code.replace(/\*/g, '.*')}$`);
}], (raw, consumed, name, code) => raw.filter(coupon => {
  if (typeof consumed !== 'undefined' && Boolean(consumed) !== Boolean(coupon.consumed)) {
    return false;
  }
  if (name && !name.test(coupon.code)) {
    return false;
  }
  if (code && !code.test(coupon.promotion.code)) {
    return false;
  }
  return true;
}).sort((a, b) => {
  if (b.promotion.rebate === a.promotion.rebate) {
    return a.promotion.code.length - b.promotion.code.length;
  }
  return b.promotion.rebate - a.promotion.rebate;
}));
export const selectOne = createSelector([selectAll], all => all[0]);
export const applyCouponToPrice = (price, coupon) => {
  if (!coupon) return null;
  if (coupon.promotion.unit !== '%') {
    return null;
  }
  return (100 - parseInt(coupon.promotion.rebate, 10)) * price / 100;
};